import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import queryString from 'query-string';
import config from 'src/config';
import { domain, domainConfig, getPromo } from 'src/helpers/domainConfig';

class Cashplane extends React.Component {
  render() {
    let name = location.host.replace('www.', '').toUpperCase();

    let title = domainConfig.title;
    let url = location.protocol + '//' + location.host;

    return (
      <div class="terms container p-5" lang="EN-US" link="blue" vlink="purple">
        <div class="Section1">
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal text-center">
            <b>
              <span class="font-arial">{name} AFFILIATE AGREEMENT</span>
            </b>
          </p>
          <p class="MsoNormal text-center">
            <span class="font-arial fs10">
              This Agreement becomes effective only if and when we accept your application.
            </span>
          </p>
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal">
            <b>
              A. Nature, Formation, Modification and Duration of Agreement, Definitions of persons mentioned
              in this Agreement
            </b>
            . This Agreement (sometimes called "<i>Terms of Service</i>" in this Agreement) is made and
            entered into by and between "{name}" (a business name of Herodot SRL, a Romania company)
            (also sometimes called "<i>we</i>" and "<i>us</i>" and "the Company" in this Agreement), and "
            <i>you</i>", a participant in the Affiliate Program administered by us, for good and valuable
            consideration, including, but not limited to our mutual promises in this Agreement, the receipt
            and sufficiency of which is hereby acknowledged by you and "{name}"; you will have expressed your
            assent, consent, and agreement to all of the terms of this Agreement by clicking on the link below
            ("Yes. I accept the Affiliate Agreement"). You become an "Affiliate" by entering into this
            Agreement when and only when we advise you that we have accepted it. We will accept it or reject
            your application after reviewing your application and investigating into it if necessary.
            Together, you and we are the "parties" as that word is used in this Agreement, but it applies only
            after we accept your application. Your participation in the Affiliate Program described in this
            Agreement is called an "Affiliation".
            <b>
              This Agreement is subject to change by us at any time through a procedure calculated and
              designed to inform you of the change
            </b>
            : Changes may include (only for the purpose of examples, but not limited to) modifications,
            alterations, and other changes in the measure, scope and amount of commission fees, commission
            schedules, payment procedures, rules of conduct and performance for Affiliates, and any other kind
            of change of any nature whatsoever with respect to the terms of this Agreement, whether like those
            mentioned or otherwise. If we decide to change this Agreement, when we do so we will send you a
            notification of each change at the email address you provided at the time when you applied to
            become an Affiliate, or if you have updated your email address in your profile, to that email
            address. We will also post the changes on the web page at this address:
            <a href="/app/terms">https://{name}/app/terms</a>. You agree that this is a reasonable procedure
            that will reasonably and effectively communicate notices of Agreement changes to you. (You also
            agree that, should you determine to discontinue the use of the email address that you provided to
            us at the time of registration, substituting another email address, you will update your online
            profile with us by changing it to reflect the newly intended email address and by deleting the
            former email address before you cease monitoring messages in the former email account, insuring
            that our emails will always be sent to your active, current, monitored email address.) You agree
            that if you use any of the Services offered by this website after we have transmitted an email to
            you in this manner and we have posted it to the page whose URL is set forth above, you thereby
            give your agreement and consent to the Agreement as it has been changed, regardless of whether you
            actually read or received the email notifying you of the change or whether you actually did or did
            not read the changes posted, and those changes will become effective to modify this Agreement
            forty&#8208;eight (48) hours after we transmitted such an email to you. If you do not wish to
            consent to the changes in this Agreement, you must immediately and from that time forward refrain
            from publishing, displaying, or using in any fashion a) the name of {name} and any other domain
            name used or owned by Herodot SRL, and b) any graphic, text-based content, and any
            trademark belonging to us. This Agreement remains in force and effect until or unless it is
            changed in accordance with the terms of this Paragraph, is otherwise terminated under the terms of
            this Agreement, or until your affiliation is terminated by us for any reason. Some of your
            obligations to us under this Agreement (and as it may, from time to time, be amended) or under any
            successor Agreement, survive any change or termination of this Agreement and/or the termination of
            your Affiliation for any reason.
          </p>
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal">
            <b>
              B. The Object of this Agreement. The purpose of this Agreement is to effect your participation
              in our Affiliate Program (as our Affiliate) and to govern the relationship thus formed: Our
              Affiliate Program is a co&shy;operative advertising program under which Affiliates drive web
              traffic to {name} and to other web sites owned by Herodot SRL by way of advertising
              and other promotional operations (with or without the benefit of our promotional materials that
              we may provide and license to you for use in such advertising), and in consideration of their
              efforts, you will be paid a monetary incentive that is computed as a share of the paid
              subscription fees resulting from your efforts. An Affiliate may be any person owning or
              controlling the operation of any web site or other operation that can be used for promotion,
              subject to the terms of this Agreement.
            </b>
          </p>
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal">
            <b>C. Enrollment in this Program. </b>
            You agree to truthfully complete and submit an Affiliate Program Application Form online through
            the Affiliate Program sign&#8208;up link on {name}. We agree to evaluate your application in good
            faith and to promptly notify you when we accept or deny your application. When this Agreement
            becomes effective, you become an Affiliate, and the affiliation begins only when we accept your
            application and notify you that your application was accepted. We may deny your application for
            any reason whatsoever or for no reason at all in our sole and exclusive discretion. This is a
            program which is intended only for adults operating legal web sites with good ethical business
            practices. We will reject your application if we determine that you have provided inaccurate or
            incomplete information in your application, if we determine that you are under 18 years of age (or
            if you are under 21 in any jurisdiction establishing that age for competence into entering into
            contracts or prohibiting persons under that age from receiving sexually explicit images) or if we
            determine in our sole and exclusive discretion that your siteís content (or your other operationís
            content, if not a website) or your business operations or location are inconsistent with the aims,
            purposes and direction of our Affiliate Program, including, but not limited to the use of images,
            video, audio, programs, scripts, or other content that is unlawful or fraudulent in any respect,
            the toleration or practice of defamation, obscenity, or harassment, or the use of operating
            practices that facilitate, promote, or assist others in illegal activity, violence, copyright
            infringement, or fraud, or for any other reason, whether like these reasons or otherwise. At the
            time of application, you must identify and register with us any website or other promotional
            operation you wish to Affiliate with our Program; thereafter you shall apply for registration of
            any other website or operation in accordance with the terms contained in Paragraph F. 14. of this
            Agreement. The term "operation" as used in this Agreement means a method of promotional
            advertising and includes but is not limited to popup, email advertising program, distributive file
            sharing program, wireless program, or any other advertising media, method, or technology.
          </p>
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal">
            <b>D. Utilizing Links on Your Site and Other Media and Promotion. </b>
            As an Affiliate of {name}, we encourage your creativity and initiative and we reward it: You may
            use any form of promotion and any media you choose that is consistent with the terms of this
            Agreement. You may use banner advertisements, wireless technology, button links, iframe ads, pop
            ups and/or text links to our site (the &quot;Links&quot;), but, you cannot employ deceptive
            language or misleading URL's in the Links, and you CANNOT MARKET BY SENDING SPAM E&#8208;MAILS!!!
            For further description of your obligations and restrictions, please see Sections F. and G. below.
            As more particularly described below in Paragraph E. 3., we will grant you, as an Affiliate
            Program member, a limited license for the use of our names and trademarks, banners, images, and
            other advertising materials for your use to stimulate sales.
          </p>
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal pbav">
            <b>E. Our Obligations to You.</b>
          </p>
          <p class="MsoNormal pbav">&nbsp;</p>
          <p class="MsoNormal ml28">
            <b>1. Commissions. </b>
            We agree to pay you 75% of the first monthís net revenues (the subscription fee actually paid by a
            subscribing customer whose membership derives from a link on your registered Affiliate website or
            other registered operation to commence the first period of his or her subscription less
            chargebacks, refunds, and processing fees) and 50% of the recurring net revenues actually paid by
            such subscriber to automatically renew his or her subscription less chargebacks, refunds, and
            processing fees.
          </p>
          <p class="MsoNormal ml28">&nbsp;</p>
          <p class="MsoNormal ml28">
            <b>2. How and When Commissions are Paid. </b>
            We agree to pay you commissions due and accrued to you under this Affiliate Program twice per
            month as described below. We will pay you via International Wire Transfer when and only when the
            commissions due to you have accrued in an amount greater than or equal to $250.00 US Dollars.
            Subject to the foregoing, we will pay you all of your commissions accrued during the 1st through
            the 15<span class="fs75">th </span>of each month on the 8<span class="fs75">th </span>of the
            following month and we will pay you all of your commissions accrued during the 15
            <sup>
              <span id="th1">th</span>
            </sup>
            <span>&nbsp;</span>through the last day of each month on the 23<span class="fs75">rd </span>of the
            following month. Notwithstanding anything contained in the foregoing, no payment will be
            transmitted to you unless your accrued commissions equal $250.00 US or more or unless the payment
            is recognized by us as our final payment to you as an Affiliate; final payments shall be governed
            by the provisions of Paragraph H. of this Agreement. Although we may, in our sole discretion,
            offer alternative payment methods, these methods, if offered, shall only be provided gratuitously
            for the convenience of Affiliates and their use shall never be a matter of our obligation. The
            discontinuation of such alternative methods, and{' '}
            <span class="msoIns">
              <ins>policy </ins>
            </span>
            changes regarding such alternative payment methods, can be made at any time in our sole and
            absolute discretion. We are only obligated to pay you via International Wire Transfer. It is your
            duty to examine our computation of your commissions as often as you are paid, and if you intend to
            dispute our computations, to inform us of any dispute immediately by means of a written or email
            claim: We agree to promptly investigate into your timely claim and to pay the disputed amount or
            to deny your claim within ninety (90) days. You agree that should you fail to inform us of your
            claim in writing or by email, particularly describing the nature and amount of your commission
            claim within sixty (60) days after the first date, upon which, you assert, the unpaid commissions
            should have been paid to you, you have thereby finally and irrevocably waived any and all claims
            concerning the amount due, the date of payment, and the manner of payment, notwithstanding any
            other term or provision of this Agreement and we shall have no duty to you to investigate into
            your untimely claim. We reserve the right to withhold any sum due to you as may be required by law
            or judicial process and to take any action with the sum as we may be required by law or the order
            of any court of competent jurisdiction. This terms contained in this Paragraph survives the
            termination of this Agreement.
          </p>
          <p class="MsoNormal ml28">&nbsp;</p>
          <p class="MsoNormal ml28">
            <b>3. License to Use our Promotional Materials. </b>
            From time to time, we will make available for your use certain advertising materials which you may
            use in your promotional work under our Affiliate Program. These materials may include banners,
            video clips, pictorial images, animations, audio clips, text, or web pages and they are likely to
            include our Logo, trademarks, service marks, and business names. For so long as this Agreement
            remains in force and effect (and only for that period), we grant you a worldwide, nonexclusive
            license to publish, distribute, copy, perform, adapt, encode or re&#8208;encode and to otherwise
            use these materials and our logo and trademarks, solely and exclusively for the purposes and
            objects of this Agreement, in any lawful manner in any media, provided that you not delete,
            remove, or render invisible any watermark or other instance of our logo or trademark nor remove
            any copyright notice or information of any character related to Title 18 United States Code
            Section 2257 concerning any promotional materials mentioned in this Paragraph. The license granted
            under this Paragraph is nontransferable and non assignable.
          </p>
          <p class="MsoNormal ml28">&nbsp;</p>
          <p class="MsoNormal ml28">
            <b>4. Acceptance of Conditions of License.</b> In utilizing links to our Program, you agree that
            you will cooperate fully with us in order to establish and maintain such links. Once established
            on a fixed web page, a link and any graphic associated with it may only be visually modified with
            our consent. You agree that you have no power to transfer, assign, sell, or lease any right
            conferred by this license and you agree that you will not attempt to do so or represent to any
            person that you may do so. Termination of this Agreement for any reason whatsoever also
            immediately terminates any and all licenses which we grant to you under this Agreement. You agree
            to immediately take down and terminate your use of our promotional materials when this Agreement
            terminates.
          </p>
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal">
            <b>F. Your Obligations to Us.</b>
          </p>
          <p class="MsoNormal">
            <b>
              The following language conveniently summarizes many of your obligations to us. Some or most of
              the obligations described in this Section are more completely recited in other parts of this
              Agreement and the more complete recitation controls if there appears to be any conflict between
              them. That a duty described elsewhere is omitted in this Section does not affect its validity
              and force. You promise and represent to us all of the following, subject to all of the terms of
              this Agreement
            </b>
          </p>
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal ml28">
            <b>1. Age, Honesty. </b>You represent to us (if you are a natural person and not a business
            entity), that you are at least 18 years old at the present time and, if you reside or operate in
            any jurisdiction establishing that age for competence into entering into contracts is 21 or
            prohibiting persons under that age from receiving sexually explicit images, you represent to us
            that you are at least 21 years of age. You agree that when you apply, your age is at least 18 or
            21, alternately, as local law shall require. You also agree that all of the other information you
            will or have provided us for any purpose at any time, before, during or after the term of your
            affiliation, will be truthful, accurate, and complete.
          </p>
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal ml28">
            <b>2. Important Business Representations. </b>
          </p>
          <p class="MsoNormal ml28">&nbsp;</p>
          <p class="MsoNormal ml56">
            <b>a) You represent to us and agree:</b>
          </p>
          <p class="MsoNormal ml56">&nbsp;</p>
          <p class="MsoNormal ml85">
            <b>1)</b>
            That you own all permits, authorizations and licenses required by law to operate your business in
            the way it is currently conducted and will be operated pursuant to and in conformity with this
            Agreement and that it is not in violation of any applicable law for you to do so; and
          </p>
          <p class="MsoNormal ml85">&nbsp;</p>
          <p class="MsoNormal ml85">
            <b>2) </b>That you have entered into no other agreements, contracts, or licenses (and have
            incurred no obligation to, with, or involving any other person) in conflict with the provisions of
            this Agreement; and
          </p>
          <p class="MsoNormal ml85">&nbsp;</p>
          <p class="MsoNormal ml85">
            <b>3)</b> That all persons employed or otherwise engaged in your performance under this Agreement
            are and will always be 18 years of age or older, and if the competent laws governing the territory
            where any work is performed prohibit persons under the age of 21 from receiving sexually explicit
            images, that any persons there employed or otherwise engaged in your performance are and always
            will be at least 21 years of age; that you will not perform or cause any person to perform any act
            in furtherance of the object of this Agreement in any jurisdiction in which the possession, sale
            distribution, or transfer of sexually explicit materials is illegal.
          </p>
          <p class="MsoNormal ml56">&nbsp;</p>
          <p class="MsoNormal ml56">
            <b>
              b) If you are entering into this Agreement as a corporation for other business entity, you
              additionally represent to us and agree as follows:
            </b>
          </p>
          <p class="MsoNormal ml85">&nbsp;</p>
          <p class="MsoNormal ml85">
            <b>1) </b>That you have been duly incorporated or organized and are validly existing as a
            corporation or other entity under the laws of your governing jurisdiction; and
          </p>
          <p class="MsoNormal ml85">&nbsp;</p>
          <p class="MsoNormal ml85">
            <b>2) </b>That performance under this Agreement does not and will not violate your articles,
            charter or by&#8208;laws, articles of organization, or any agreement or instrument to which
            governs you or to which you are a party or any law, rule or regulation applicable to or binding
            upon you.
          </p>
          <p class="MsoNormal ml28">&nbsp;</p>
          <p class="MsoNormal ml28">
            <b>3. Duty to Read Our Messages. </b>You agree to promptly read the email messages and any other
            communications we send you. As otherwise provided in Section A of this Agreement, If our email
            announces a change or modification of this Agreement and you do not wish to agree to them, you
            agree that you must immediately cancel your affiliation: You will be bound by those changes or
            modifications unless you fail to immediately cancel your affiliation.
          </p>
          <p class="MsoNormal ml28">&nbsp;</p>
          <p class="MsoNormal ml28">
            <b>4. Duty to Check for Updates to This Agreement. </b>You agree to click on the Affiliate Program
            Terms of Service link located online at{' '}
            <a href="https://{name}/app/terms">https://{name}/app/terms</a> to check for changes or
            modifications in these Terms of Service as frequently as you access your Affiliate Program account
            page on {name}.
          </p>
          <p class="MsoNormal ml28">&nbsp;</p>
          <p class="MsoNormal ml28">
            <b>5. Duty to Update Email Information. </b>You agree to update your email address through your
            Affiliate Program account page on {name} as often as it changes.
          </p>
          <p class="MsoNormal ml28">&nbsp;</p>
          <p class="MsoNormal ml28">
            <b>6. Duty to Read and Understand this Agreement. </b>You agree to read the provisions of this
            Agreement and to ensure that your conduct conforms to the rules and obligations set forth in them
            in every respect at all times. You agree not do any of the things that this Agreement prohibits.
            You agree to seek amplification or explanation from us in regard to any term, wording, or
            provision that you do not understand or which seems confusing or vague to you and to accept our
            explanation or interpretation, in our sole discretion, as authoritative, final, and controlling.
            Your continued participation in our Affiliate Program thereafter constitutes your acceptance of
            our interpretation of any such term, wording, or provision. You understand that more detailed
            Affiliate Standards of Conduct are contained in this in Section F. of Agreement and that, by
            accepting this Agreement, you are bound by them as they are presently articulated and as they may,
            in the future, be changed or modified in accordance with the terms of this Agreement.
          </p>
          <p class="MsoNormal ml28">&nbsp;</p>
          <p class="MsoNormal ml28">
            <b>7. Duty to Obey the Law. </b>You agree to obey the laws of every jurisdiction, national, state
            or provincial, and local that has authority over you in every activity connected in any way with
            your affiliation with {name}. Important details concerning your obligations are contained in this
            Agreement under Affiliate Standards of Conduct.
          </p>
          <p class="MsoNormal ml28">&nbsp;</p>
          <p class="MsoNormal ml28">
            <b>8.</b> <b>Our Relationship as Independent Contractors. </b>You agree that you and Herodot SRL 
            doing business as {name} are independent contractors standing at armís length, and nothing
            in this Agreement and nothing in any subsequent written or oral statement and nothing in any
            course of conduct or dealings will create any partnership, joint venture, agency, franchise, sales
            representative, or employment relationship between the parties except that a written agreement
            manually signed on paper by you and by an authorized representative of Herodot SRL doing
            business as {name} may establish such a relationship. You have and will have no authority under
            this Agreement or through any future dealings of pattern of conduct to make or accept any offers
            or representations on our behalf. You will not make any statement, whether on your site or in your
            other operation or otherwise, nor take any action, that would state, imply, or be reasonably
            understood to suggest the existence of any such relationship or authority as is disclaimed in this
            Paragraph, nor shall you remain silent in circumstances under which your silence would reasonably
            tend to be taken to affirm such a disclaimed relationship or authority, but it will, rather, be
            your duty to affirmatively disclaim and deny such a relationship. You are not our agent and 
            Herodot SRL doing business as {name} expressly disclaims responsibility for any statement or
            conduct by you on our behalf. Without prejudice to or any purpose of limitation of the foregoing,
            and exclusively for the purpose of example, you will be solely responsible for the development,
            operation and maintenance of your site or other promotional program and for all materials that
            appear in or on it; we shall have no responsibility for the development, operation and maintenance
            of your site nor the materials that appear on your site. We shall have no obligation to
            investigate into your site or its Content nor your business operations but we reserve the right to
            do so for any reason, for no reason, or whenever credible evidence suggesting a violation of this
            Agreement comes to our attention.
          </p>
          <p class="MsoNormal ml28">&nbsp;</p>
          <p class="MsoNormal ml28">
            <b>9. Your Affiliate Password. </b>You agree that you will not share your password for access to
            your Affiliate Program account information page with any other person, nor through oversight or
            negligence allow any other person to learn it. You will not permit anyone other than yourself or
            us to gain access to your account page. You will notify us immediately through the most rapid and
            sure means available to you when you learn or suspect that the confidentiality of your password
            has been compromised.
          </p>
          <p class="MsoNormal ml28">&nbsp;</p>
          <p class="MsoNormal ml28">
            <b>10. Nontransferability. </b>You understand that your affiliation entitles you{' '}
            <i>and only you </i>and your registered websites or other registered operations to participate in
            this Affiliate Program, and that no right or privilege or access granted to you concerning the
            Program can be sold, assigned, leased, given, rented, entrusted, or transferred by you to any
            other person without our prior consent in writing. You promise that you will not do or attempt to
            do any of those things.
          </p>
          <p class="MsoNormal ml28">&nbsp;</p>
          <p class="MsoNormal ml28">
            <b>11. Duty of Good Faith, Truthful Co&shy;operation. </b>You promise that, in all of your
            dealings with us, you will always be truthful and that you will never attempt to cheat, defraud or
            mislead us in any way by your statement or that of any other person, by silence calculated or
            likely to mislead us, or through your act or omission. You also agree that you will diligently,
            and in good faith co&#8208;operate with us in any investigation we may conduct concerning our
            Affiliate Program, including but not limited to the operations, policies, and activities of
            Affiliates or in respect to matters that may be relevant to the Affiliate Program or participation
            in it. You agree that you will provide us with accurate, truthful, and complete statements,
            information, correspondence, records, and/or documents, promptly upon our request, and if asked to
            do so, you will provide statements under oath and certify the authenticity of documents. If
            requested by us to do so, you will truthfully testify in depositions, hearings, and trials. You
            agree that you will not be entitled to any compensation in consideration of your assistance beyond
            reimbursement for your out of pocket expenses incurred with our knowledge prior to your
            expenditure of funds. This provision survives the termination of this Agreement for any reason.
          </p>
          <p class="MsoNormal ml28">&nbsp;</p>
          <p class="MsoNormal ml28">
            <b>12. Duty to Inform Us of Termination.</b>You agree to tell us when you want to call it quits
            and terminate your participation in our Affiliate Program by doing so in a writing actually
            delivered to us. Some of your obligations under this Agreement will survive after termination as
            provided in this Agreement.
          </p>
          <p class="MsoNormal ml28">&nbsp;</p>
          <p class="MsoNormal ml28">
            <b>13. License and Use of Affiliate Logos and Trademarks. </b>You grant us a nonexclusive,
            worldwide license to utilize the names, titles logos, service marks, and trademarks you employ, in
            any media, for the purpose of advertising, marketing, promoting and publicizing, in any manner.
            Notwithstanding any term herein apparently to the contrary, we shall not be required to so
            advertise, market, promote or publicize your operations. You hereby represent and warrant that you
            are the sole and exclusive owner of all of the names, titles, logos, service marks, and trademarks
            that you employ and that you have the right and power to grant to us a valid and unconditional
            license to use same in the manner contemplated herein, and that your license to us does not or
            will not (i) breach, conflict with or constitute a default under any agreement or other instrument
            applicable to you or binding upon you, or (ii) infringe upon any trademark, trade name, service
            mark, copyright, or other proprietary right of any other person or entity. Termination of this
            Agreement also immediately terminates any and all licenses which you grant to us under this
            Agreement.
          </p>
          <p class="MsoNormal ml28">&nbsp;</p>
          <p class="MsoNormal ml28">
            <b>14. Registration of Websites and other Operations. </b>You must register each website or other
            operation that is part of this Affiliate Program with us when you apply to become an Affiliate.
            Any other website or other operation thereafter to be added to the Affiliate Program must be
            registered with us before any use is made of our materials or other intellectual property.
          </p>
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal">
            <b>
              <a name="asc">G.</a> Affiliate Standards of Conduct.
            </b>
          </p>
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal">You agree as follows:</p>
          <p class="MsoNormal ml28">&nbsp;</p>
          <p class="MsoNormal ml28">
            <b>
              1. ABSOLUTE PROHIBITION OF E&shy;MAIL SPAM AND EVERY OTHER KIND OF UNSOLICITED DIRECT MARKETING.{' '}
            </b>
            Our policy against email spam and other electronic unsolicited direct marketing techniques is
            critically important to us because spam is seriously and dangerously illegal and any potential
            connection to these crimes imperils our continued existence. We have absolutely zero tolerance for
            spam and we will terminate your affiliation when we have any firm suspicion that you are engaged
            in spamming. We are unwilling to enter into any relationship with any person who does not take
            this matter as seriously as we do and who is unwilling to commit to our policy without any
            reservation. Accordingly, you agree that you (yourself or through any agent, employee, contractor
            or intermediary) will never utilize spam any unsolicited bulk email, any instant message spam, any
            newsgroup spam, any spam in blogs, any wiki spam, any mobile phone messaging spam, any internet
            forum spam, any unsolicited fax transmissions, any file sharing network spam, or any unsolicited
            posts on social networking sites such as Myspace.com, Facebook.com and the like. The term "spam"
            as used here includes, but is not limited to, any email, message or other communication of any
            kind, without limitation, transmitted in violation of the United States CAN-SPAM Act, Title 15
            United States Code Chapter 103 and Sections 7701 through 7713 thereof and all regulations
            promulgated by the United States Federal Trade Commission in implementation of those statutes, as
            they exist now and as they later may be amended or added to, and any other email, message, or
            other communication of any kind, without limitation, regardless of its place of origin, which
            would violate those same provisions of law were it to be transmitted from within the jurisdiction
            of the United States of America.{' '}
            <b>
              You acknowledge your understanding of our policy, that one instance of spam in violation of the
              provisions set out in this Paragraph will cause us to terminate our Agreement with you and your
              status as an Affiliate. You also agree that, should you violate the prohibitions of this
              Paragraph, in view of the serious damage you will have caused to us, the economic value of which
              is difficult to estimate or calculate at this time, you shall forfeit to us any and all unpaid
              commissions otherwise payable to you, without prejudice to our right to recover from you any and
              all additional damages to which we may be entitled under law. You also acknowledge that we may
              bring an action against you to recover damages for such conduct and inform law enforcement
              agencies as to your identity, providing to them any and all evidence in our possession
              concerning your conduct. You also agree that, should we file an action against you in any
              competent court based on a violation of the provisions of this Paragraph, and should we prevail,
              we shall be entitled also to recover from you any and all reasonable attorneyís fees and the
              reasonable costs of litigation.{' '}
            </b>
            The United States CAN-SPAM Act, Title 15 United States Code Chapter 103 and Sections 7701 through
            7713, are incorporated into this Agreement as though set out in full at this place and may be read
            and examined at the following link:{' '}
            <a href="http://uscode.house.gov/">
              <span class="fs110">http://uscode.house.gov/</span>
            </a>
            <span class="fs110">. </span>The regulations implementing the CAN-SPAM Act, contained in 16 Code
            of Federal Regulations Part 316, are also incorporated into this Agreement as though set out in
            full at this place and may be read and examined at the following link:{' '}
            <a href="http://www.ftc.gov/">http://www.ftc.gov/</a>. These links are provided as a courtesy and
            the targets of each link reflect the legal text in existence at the time that this Agreement was
            drafted; your obligations under this Agreement shall be to comply with the laws contained within
            that Chapter and Part as they now exist and as they may be amended or added to in the future; it
            is therefore prudent that you periodically keep abreast of the current text of those provisions.
          </p>
          <p class="MsoNormal ml28">&nbsp;</p>
          <p class="MsoNormal ml28">
            <b>2. Intellectual Property Rights Violations Prohibited. </b>You agree that so long as you
            participate in our Affiliate Program, you will not use for any promotional, advertising or
            commercial purpose any Content that infringes the copyright, trademark, patent, trade secret
            rights, or other intellectual property of any person or which violates the right to privacy of any
            person, including but not limited to the rights of publicity, publication, false light, the
            unauthorized public disclosure of private information, or the unauthorized publication,
            communication, or distribution of Personal Identification Information, nor will you otherwise use
            any Content in a manner that amounts to a tort against us or a third person including, but not
            limited to, defamation or intentional infliction of emotional distress. Without limiting the
            foregoing, you agree that you will not use any Content for which you do not possess all
            Publication Rights necessary for your intended use of that Content nor unless you possess written
            evidence of those Publication Rights. You agree that so long as you participate in our Affiliate
            Program, you will not, for any promotional, advertising or commercial purpose utilize any Content
            unless you own all copyrights associated with such content and unless you can prove to us that you
            own all such copyrights, or through the written permission of all copyright holders associated
            with the Content signed by such copyright holders, granting you permission or license to use the
            Content as you wish to use it, establish your right to do so, or unless the Content is in the
            public domain and you possess written evidence that the content is in the public domain. You agree
            that you will not use any content for any promotional, advertising or commercial purpose unless
            you have secured and possess full and unconditional written releases and waivers of all of the
            personal rights of all of the writers, performers, models, photographers, designers, artists,
            employees, land, building, or property owners, and of all other persons, as may be or may appear
            to be necessary, for the plenary and free publication of Content germane to this Agreement in a
            graphic, sexually&#8208;oriented web site without injury or offense to the rights of any person,
            with regard to any Content germane to this Agreement.
          </p>
          <p class="MsoNormal ml28">&nbsp;</p>
          <p class="MsoNormal ml56">
            Definitions<b>:</b>
          </p>
          <p class="MsoNormal ml56">&nbsp;</p>
          <p class="MsoNormal ml56">
            <b>a.</b> The term, "<i>Content</i>". as we use it in this Agreement means all text, graphic or
            computer designs, programs, or scripts, and any and all fruits of any and all types of still and
            moving photography, videography, digital image, streams, and/or sound acquisition, and any other
            method or technical process by which images and/or sound can be recorded, fixed, projected,
            transmitted, streamed, displayed, or played back, including, without limitation, negatives,
            prints, digital files, streams, video feeds, illustrations, pictures, designs, paintings and
            drawings of every kind and nature and every part and element thereof, and the text and voice
            communication and vocal expression of a performer.
          </p>
          <p class="MsoNormal ml56">&nbsp;</p>
          <p class="MsoNormal ml56">
            <b>b.</b> The term "<i>Personal Identification Information</i>", as we use it in this Agreement,
            means all information personally associated with any identifiable person by law or custom,
            including without limitation, the name of and images depicting a person including any personís
            actual or real name, any aliases, nicknames, professional names, maiden names, or
            pre&#8208;adoptive names, any email address, the number associated with any bank account, debit
            card or credit card owned by or issued to any person at any time, any Personal Identification
            Number or other numbers or codes used for verification or security for any purpose and any
            username or username/password combination used or issued to be used online for access to any email
            account or to obtain services from any website or any interactive computer service of any nature
            whatsoever.
          </p>
          <p class="MsoNormal ml56">&nbsp;</p>
          <p class="MsoNormal ml56">
            <b>c.</b> The term "<i>Publication Rights</i>" means the permission of each and every person
            visually depicted or heard in an audio track, the owner of the places depicted, the owner of any
            trademark depicted, the owners of any trade secrets used, disclosed, or depicted, the person to
            whom personal identification information relates or with whom it is associated, and the written
            license of any and all copyright holders , authors, and inventors possessing any rights whatsoever
            in the content.
          </p>
          <p class="MsoNormal ml28">&nbsp;</p>
          <p class="MsoNormal ml28">
            <b>3. Personal Harm Prohibited.</b>You agree that so long as you participate in our Affiliate
            Program, you will not, for any promotional, advertising, or commercial purpose, engage in any
            conduct that amounts to the abuse, harassment, bullying, stalking or defamation of any person or
            give any help, encouragement, or assistance to any other person doing these things, nor
            communicate any threat to any person, communicate any threat of suicide, promote racism, bigotry,
            hatred, animal cruelty, or physical harm of any kind against any group or individual, nor
            communicate with any person who has asked you not to contact him, her, or it.
          </p>
          <p class="MsoNormal ml28">&nbsp;</p>
          <p class="MsoNormal ml28">
            <b>4. Illegal and Fraudulent Conduct Prohibited. </b>You agree that so long as you participate in
            our Affiliate Program, you will not, for any promotional, advertising or commercial purpose,
            engage in any conduct that amounts to the violation of any law or the promotion of or facilitation
            of illegal or fraudulent conduct under the laws of any jurisdiction in which {name} or any other
            web sites owned by Herodot SRL may be accessed, including, but not limited to
            solicitation of any offense, the promotion, publication, or distribution of an illegal or
            unauthorized copy of another person's copyrighted work, including but not limited to pirated
            computer programs or music files, providing information to circumvent manufacturer&#8208;installed
            copy&#8208;protection devices, the unauthorized publication, distribution, or communication of any
            usernames or passwords, or the publication, distribution or communication of links to place where
            the same are available.
          </p>
          <p class="MsoNormal ml28">&nbsp;</p>
          <p class="MsoNormal ml28">
            <b>5. Promotion of Illegal Conduct Prohibited. </b>You agree that so long as you participate in
            our Affiliate Program, you will not, for any promotional, advertising or commercial purpose,
            engage in any advertising, promotion, posting, product, service, relationship, business, commerce,
            offer, agreement, proposal, message, or communication that is illegal under the laws of any
            jurisdiction in which {name} or any other web sites owned by Herodot SRL may be
            accessed. Without limitation of the foregoing, you shall comply with the laws of every
            jurisdiction requiring a Privacy Statement disclosing the uses to which you will apply personal
            information acquired from users or visitors.
          </p>
          <p class="MsoNormal ml28">&nbsp;</p>
          <p class="MsoNormal ml30">
            <b>6. Deceptive Practices Prohibited. Fake Profiles and Communications. </b>You agree that so long
            as you participate in our Affiliate Program, you will not, for any promotional, advertising or
            commercial purpose use any unfair, untrue, misleading, unfairly competitive, fraudulent or
            deceptive act, practice, communication, or statement whether or not criminal under the laws of any
            jurisdiction in which {name} or any other web sites owned by Herodot SRL may be
            accessed, or which is calculated to achieve any such purpose. Without limitation of the forgoing
            and only for the purposes of an example, it is prohibited to create, establish or publish any fake
            profile (not authorized by a real person to whom it actually relates and whom it describes or
            depicts in any fashion, accurately or inaccurately) for any commercial or marketing purpose
            relating to your activities as an Affiliate nor to send to any person any email, message, or
            communication (or to operate a program or script which does so) for such a purpose. You agree that
            you will not employ any script, program, or other method or technique by which messages, emails,
            replies, or other communications may be generated and/or transmitted automatically (other than
            your "out of the office" automatic reply to emails or messages stating that you are unavailable
            and may be reached at a later time).
          </p>
          <p class="MsoNormal ml30">&nbsp;</p>
          <p class="MsoNormal ml30">
            <b>7. Use of Viruses Prohibited. </b>You agree that so long as you participate in our Affiliate
            Program, you will not utilize, publish, distribute, copy, or transmit any program, file, data
            stream or other material which contains viruses, worms, &quot;Trojan horses&quot; or any other
            destructive or invasive program, regardless whether damage is intended or unintended, which may
            cause damage to any computer equipment, the loss or corruption of data or programs, an
            inconvenience to any person, or any alteration of any personís computerís settings or
            configuration;
          </p>
          <p class="MsoNormal ml30">&nbsp;</p>
          <p class="MsoNormal ml30">
            <b>8. Protection of Minors. </b>You agree that so long as you participate in our Affiliate
            Program, you will not, for any promotional, advertising or commercial purpose distribute, publish,
            or solicit any Personal Identification Information or sexual information about any person under
            the age of eighteen years, whether with or without the consent of that person.
          </p>
          <p class="MsoNormal ml30">&nbsp;</p>
          <p class="MsoNormal ml30">
            <b>9. Chain Letters and Ponzi Schemes Prohibited. </b>You agree that so long as you participate in
            our Affiliate Program, you will not utilize or participate in chain letters, pyramid schemes and
            lotteries, nor promote or advertise of any of them;
          </p>
          <p class="MsoNormal ml30">&nbsp;</p>
          <p class="MsoNormal ml30">
            <b>10 Information About Dangerous Articles Prohibited. </b>You agree that so long as you
            participate in our Affiliate Program, you will not publish or distribute information concerning
            the use, possession, sale, distribution, availability, or manufacture of drugs, drug
            paraphernalia, explosives, weapons, radioactive materials, infectious or weaponized biological
            agents, toxic gasses, poisons, venoms, or other toxic or hazardous substances; You will not
            violate any provision of United States law relating to the export of or disclosure of sensitive
            information, programs or other material so regulated by its laws.
          </p>
          <p class="MsoNormal ml30">&nbsp;</p>
          <p class="MsoNormal ml30">
            <b>11. Section 2257 Compliance Mandated. </b>You agree that so long as you participate in our
            Affiliate Program, you will not, for any promotional, advertising or commercial purpose utilize,
            distribute, or publish erotic images unless they comply with the current provisions of Title 18
            United States Code Section 2257 and its implementing federal Regulations in force and effect as
            most recently authoritatively interpreted by the courts of the United States or by the Department
            of Justice, regardless of whether those statutes and regulations are ultimately constitutional.
          </p>
          <p class="MsoNormal ml30">&nbsp;</p>
          <p class="MsoNormal ml28 ti165">
            <b>12. Obscenity and Other Prohibited Depictions. </b>You agree that so long as you participate in
            our Affiliate Program, you will not, for any promotional, advertising, or commercial purpose
            create, utilize, distribute, or publish any content depicting or describing bestiality,
            necrophilia, coprophilia, urine, vomit, blood, gagging, rape or other nonconsensual sexual conduct
            or contact, the simulation of sex with persons under the age of 18, the infliction of apparently
            serious pain, torture, the sexual penetration of restrained or bound or gagged or blindfolded or
            suspended persons, corpses, diseases, surgery, violence upon persons or animals or the sexual
            activity of persons with physical or mental disabilities or handicaps or any other content which
            is legally obscene in Romania, the United States, Canada, or in any jurisdiction in which
            {name} or any other web sites owned by Herodot SRL may be accessed.
          </p>
          <p class="MsoNormal ml28 ti300">&nbsp;</p>
          <p class="MsoNormal ml28 ti165">
            <b>13. Child Pornography Prohibited. </b>You agree that so long as you participate in our
            Affiliate Program, you will not create, possess, distribute, or publish any child pornography as
            defined by the laws of Romania, the United States, Canada, or any subordinate jurisdiction of any
            of them, nor any depiction or description of nudity, semi&#8208;nudity, or any sexual conduct
            with, of, or by a person under the age of eighteen.
          </p>
          <p class="MsoNormal ml28 ti300">&nbsp;</p>
          <p class="MsoNormal ml28 ti165">
            <b>14. Promotion and Protection of Goodwill. </b>You agree that so long as you participate in our
            Affiliate Program, you will not take any act that, alone or in its context, would tend to injure
            or diminish the goodwill or good reputation of Herodot SRL, its {name} website, or any
            other web sites owned by Herodot SRL, or subject it to liability or embarrassment as we
            may determine in our sole and absolute discretion, whether your conduct is illegal or otherwise,
            without restriction.
          </p>
          <p class="MsoNormal ml28 ti300">&nbsp;</p>
          <p class="MsoNormal ml28 ti165">
            <b>15. Prohibited Jurisdictions: </b>You represent to us that you are not located in any of the
            jurisdictions set forth in this Paragraph and that, during the term of this Agreement, you will
            undertake no promotional advertising or business operations yourself or through any other person
            (concerning the websites that you now seek to register or later register with our Affiliate
            Program) in any of them: Cuba, the Democratic Peopleís Republic of Korea (North Korea), Myanmar
            (Burma), Libya, Sudan, Syria, and Nigeria.
          </p>
          <p class="MsoNormal ml28 ti165">&nbsp;</p>
          <p class="MsoNormal ml28 ti165">
            <b>16. Confidentiality.</b>
          </p>
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal ml56 ti300">
            <b>a) </b>&quot;<b>Confidential Information&quot; </b>means any data or information developed or
            acquired by us related in any way to the object of this Agreement regarding the operation of 
            Herodot SRL and the identity, Personal Identification Information, operations, or methods and
            techniques of its Affiliates, contractors, agents, models, performers, subscribers, participants,
            or the principals of any of them, which could reasonably be regarded as confidential and the
            disclosure of which would be harmful to Herodot SRL (or those of its Affiliates,
            contractors, agents, models, performers, subscribers, participants, or the principals of any of
            them) and, particularly, but without limitation, all information including ideas, concepts,
            projects and projections, specifications, records, forms, templates, scripts, data,
            know&#8208;how, models, plans, business and/or marketing plans, programs, algorithms, software
            (source code, object code and related documentation), products, formulas, systems, methods,
            processes, discoveries, technological inventions, artistic works, as well as other all other
            technical or commercial information whether patentable or not, whether copyrightable or not, or in
            whatever form they may take (digital, analog, hard copy, or otherwise without limitation); without
            limitation of the foregoing, "Confidential Information" includes any and all unpublished
            information not generally known in the adult entertainment industry which we have treated as
            confidential and which we identify to you as confidential when we disclose it to you; Confidential
            Information remains Confidential Information until Herodot SRL voluntarily makes the
            information public without coercion, duress, or as it may be required to do so by law, subpoena,
            or other judicial process.
          </p>
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal ml56 ti300">
            <b>b) Obligations Regarding Confidential Information. You agree as follows:</b>
          </p>
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal ml85 ti300">
            <b>1) </b>From time&#8208;to&#8208;time, you may be exposed to the Confidential Information of
            Herodot SRL doing business as {title};
          </p>
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal ml85 ti300">
            <b>2) </b>You agree that you will take all appropriate steps to protect the Confidential
            Information of Herodot SRL doing business as {title} from unauthorized disclosure;
          </p>
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal ml85 ti300">
            <b>3) </b>You agree that you will not disclose such Confidential Information to any third party
            except as may be required by law.
          </p>
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal ml85 ti300">
            <b>4) </b>You agree that you will not use any Confidential Information (other than as authorized
            by this Agreement) without the prior written consent to such effect of an authorized
            representative of {name}.
          </p>
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal ml85 ti300">
            <b>5) </b>You agree that you shall use the Confidential Information disclosed to you solely for
            the purpose of carrying out your responsibilities and obligations, through your officer, agents,
            servants, employees, attorneys, accountants, and contractors under the terms of this Agreement.
          </p>
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal ml85 ti300">
            <b>6) </b>You agree that you shall take the same measures to protect the confidential nature of
            the Confidential Information disclosed to you as you take to protect your own trade secrets and
            other Confidential Information (but in no event with less than commercially reasonable care).
          </p>
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal ml85 ti300">
            <b>7) </b>Your obligation with respect to Confidential Information shall continue until such
            information is no longer deemed Confidential Information under this Agreement. This provision
            survives the termination of this Agreement for any reason.
          </p>
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal ti300 ml56">
            <b>c) </b>Your obligations of confidentiality hereunder shall not extend to information which you
            can document (a) was previously known by you, prior to any disclosure from Herodot SRL
            doing business as {title}, as evidenced in written documentation or other tangible forms dated
            prior to such disclosure; (b) is generally available to or known by the trade; (c) was received
            from any person without restriction and not in violation of any duty of nondisclosure on the part
            of such person; (d) is used for the purposes of mediation, arbitration, or litigation hereunder,
            or (e) must be disclosed pursuant to the order of a court, administrative agency, or other
            governmental body of competent jurisdiction, provided that you agree that you will, in the case of
            a disclosure pursuant to (e) first have provided Herodot SRL doing business as {title}
            with prompt, prior written notice of such required disclosure and you agree that you will take
            reasonable steps to allow Herodot SRL doing business as {title} to seek a protective
            order with respect to the confidentiality of the information required to be disclosed; and
            promptly cooperate with and assist Herodot SRL doing business as {title} in connection
            with obtaining such protective order.
          </p>
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal">
            <b>H. Term of This Agreement. Liquidated Damages. </b>The term of this Agreement will begin upon
            our acceptance of your Affiliate Program Application and will end when terminated by either party
            or by operation of law. Either you or Herodot SRL may terminate this Agreement at any
            time for any reason or for no reason, by giving the other party notice of termination. Our notice
            by e&#8208;mail, to your e&#8208;mail address on our records, will be sufficient to terminate this
            Agreement. You also agree that, should you breach any terms of this Agreement, and should we
            terminate this Agreement with you for as a result of your breach of its terms, in view of the
            damage you will have caused to us, the economic value of which, we mutually agree, is difficult to
            estimate or calculate categorically at this time, you shall, at a minimum, forfeit to us any and
            all unpaid commissions otherwise then payable to you, and any and all subsequent commissions
            otherwise payable to you based on future recurring payments.<b> </b>If we terminate this Agreement
            because you have violated the terms of this Agreement we will notify you of the basis for our
            termination, but we will not pay you any further commission payments, even for commissions earned
            prior to the date of termination, and without prejudice to our right to bring an action against
            you to recover our additional damages arising from your breach of this Agreement, should they
            exceed the amount you have forfeited to us on that account. If this Agreement is terminated other
            than by us on the basis of your breach of the terms of this Agreement, we will thereafter pay you
            only commissions already actually earned at the time of termination and derived from subscriber
            payments actually made during the term of the Agreement and not thereafter charged back, refunded
            or otherwise voided, less processing fees; in such case, we shall not pay you any subsequent
            commissions otherwise payable to you based on future recurring payments. We reserve the right to
            withhold your final payment for a reasonable time to ensure that the correct amount is paid in
            consideration of the possibility of chargebacks, refunds, or other events which may affect the
            final commission payable to you. We reserve the right to generally terminate the Affiliate Program
            described in this Agreement or any part of it, at any time, for any reason or for no reason, with
            or without prior public notice or notice to you, in our sole and exclusive discretion. We reserve
            the right to withhold any sum due to you as may be required by law or judicial process and to take
            any action with the sum as we may be required by law or the order of any court of competent
            jurisdiction. Certain provisions of this Agreement survive the termination of this Agreement for
            any reason.
          </p>
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal">
            <b>I. Disclaimer of any Warranties.</b> {name} GRANTS NO WARRANTIES, EXPRESS OR IMPLIED, INCLUDING
            BUT NOT LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
            OTHER THAN THOSE WHICH ARE IMPLIED BY LAW AND INCAPABLE OF EXCLUSION, RESTRICTION OR MODIFICATION
            UNDER APPLICABLE LAW. IT DISCLAIMS ANY WARRANTY OF MERCHANTABILITY ANY AND ALL WARRANTIES OF
            FREEDOM FROM PATENT, TRADEMARK OR COPYRIGHT INFRINGEMENT, ANY WARRANTY OF NONOBSCENITY AND ANY
            WARRANTY AS TO PUBLICATION RIGHTS. {name} DISCLAIMS ANY IMPLIED WARRANTIES OTHERWISE ARISING OUT
            OF A COURSE OF PERFORMANCE, DEALING, OR TRADE USAGE. NO ORAL OR WRITTEN INFORMATION OR ADVICE
            GIVEN BY {name}, ITS AGENTS OR EMPLOYEES SHALL CREATE A WARRANTY. NO TERM OF THIS AGREEMENT MAY BE
            MODIFIED OR CHANGED EXCEPT AS EXPLICITLY PROVIDED BY ITS TERMS AND YOU AGREE THAT NO ORAL
            REPRESENTATION OR STATEMENT OF ANY REPRESENTATIVE OF
            {name} IS RELIED UPON BY YOU IN ENTERING INTO THIS AGREEMENT. YOU UNDERSTAND AND AGREE THAT ALL
            CONTENT PROVIDED IS PROVIDED &quot;AS IS&quot; WITH NO WARRANTY OF ANY SORT WHATSOEVER.
            {name} MAKES NO REPRESENTATION THAT THE OPERATION OF OUR PROGRAM WILL BE UNINTERRUPTED OR
            ERROR&#8208;FREE, AND WE DISCLAIM ANY LIABILITY FOR THE CONSEQUENCES OF ANY INTERRUPTIONS OR
            ERRORS. {name} IS NOT RESPONSIBLE TO YOU FOR ANY DELAY IN TRANSMISSION OF CONTENT OR PROGRAM
            DOWNTIME, NOR FOR ANY VIRUS, TROJAN HORSE, WORM, OR OTHER DELETERIOUS PROGRAM OR INSTRUCTION THAT
            YOU MAY RECEIVE AS A RESULT OF YOUR AFFILIATION. IN NO EVENT SHALL {name}
            BE LIABLE TO YOU OR ANY OTHER PERSON FOR LOSS OF BUSINESS, PROFITS OR DATA, OR FOR ANY INDIRECT,
            INCIDENTAL OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE USE OF, OR INABILITY TO USE ANY PART OF OUR
            AFFILIATE PROGRAM OR THE CONTENTS THEREOF, EVEN IF {name} WAS PREVIOUSLY ADVISED OF THE
            POSSIBILITY OF SUCH DAMAGES OR FOR ANY OTHER CLAIM BY YOU OR BY ANY OTHER PERSON. SOME
            JURISDICTIONS DO NOT PERMIT A DISCLAIMER OF CONSEQUENTIAL DAMAGES; YOU SHOULD CONSULT THE LAWS OF
            THE RELEVENT JURISDICTION IN ORDER TO DETERMINE THE EFFICACY OF THE FOREGOING DISCLAIMER OF
            CONSEQUENTIAL DAMAGES. YOU AGREE THAT YOUR SOLE AND EXCLUSIVE REMEDY IN THE EVENT OF A BREACH OF
            THIS AGREEMENT BY {name} IS DAMAGES LIMITED TO THE TOTAL COMMISSIONS PAID OR PAYABLE TO YOU UNDER
            THIS AGREEMENT.
          </p>
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal">
            <b>J. Indemnification, Notice, and Defense. </b>You hereby agree to indemnify, defend and hold
            harmless Herodot SRL, its shareholders, officers, directors, employees, agents,
            attorneys, Affiliates, successors and assigns, from and against any and all claims, losses,
            liabilities, damages or expense (including attorneys' fees and costs) of any nature whatsoever
            incurred or suffered by us (collectively the &quot;Losses&quot;), in so far as such Losses (or
            claims in respect thereof) arise out of or are based on (i) any claim or threatened claim that our
            use of your trademark or service mark infringes on the rights of any third party; (ii) the breach
            of any promise, covenant, representation or warranty made by you herein; or (iii) or any claim
            related to your site or its contents or your operations. You agree to so defend us through
            independent attorneys of our own selection in our sole and absolute discretion. You agree to
            immediately and promptly inform us of any and all claims, lawsuits, subpoenas, or orders
            concerning us or arising from, your websites and other operations affiliated with our Affiliate
            Program, and the activities associated in any way with any of them; you promise to so advise us
            through the most rapid and sure means at your disposal and to co-operate with us in our defense in
            every regard as otherwise provided in this Agreement.
          </p>
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal">
            <b>K. Terminated Accounts. </b>Terminated Affiliates are not permitted to apply for participation
            in our Affiliate Program without seeking permission to do so in writing or via email. Any
            application by or on behalf of or for the benefit of a terminated Affiliate without prior
            identification of the terminated Affiliate as such or otherwise hiding or concealing his identity
            or status as a terminated Affiliate from us is an act of fraud against {name} and any contract
            ensuing from such fraud shall be null and void; In such case, {name} may withhold any and all
            commissions and shall have the right to recover any commissions previously paid.
          </p>

          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal">
            <b>L. </b>
            <b>Nonwaiver.</b>
            Except as otherwise expressly provided herein, our failure at any time to take action against you,
            shall not affect our right to require full performance of this Agreement at any time thereafter,
            and our waiver of a breach of any provision of this Agreement shall not constitute a waiver of any
            prior or subsequent breach of this Agreement nor nullify the effectiveness of any breached
            provisions nor our right to demand redress for its losses and damages. No waiver of any breach of
            any term or provision hereof by {name} shall be effective or binding unless made in writing and
            signed by a representative of Herodot SRL authorized to give the same and, unless
            otherwise provided, shall be limited to the specific breach so waived.
          </p>
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal">
            <b>M. Binding on Successors. </b>This Agreement shall be binding on and shall inure to the benefit
            of the parties hereto, and their heirs, administrators, successors, trustees and assigns.
          </p>
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal">
            <b>N. Severability. </b>If any provision hereof is held invalid or unenforceable by arbitration or
            litigation in a court of competent jurisdiction, such invalidity, shall not affect the validity or
            operation of any other provision and such invalid provision shall be deemed to be severed from
            this Agreement.
          </p>
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal">
            <b>O. Integration. </b>This Agreement constitutes the entire agreement of the parties, and revokes
            and supersedes all prior agreements between the parties and is intended as a final expression of
            their agreement. This Agreement shall not be modified, changed or amended except as provided
            herein or in a writing signed by both parties. This Agreement shall take precedence over any other
            documents that may be in conflict therewith.
          </p>
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal">
            <b>P. Attorney Fees. </b>In the event of any action, litigation, arbitration, suit or proceeding
            arising from or under the terms, provisions or conditions of this Agreement, the prevailing Party
            shall be entitled to recover reasonable attorneysí fees and costs of suit or other proceeding from
            the other party who has not substantially prevailed.
          </p>
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal">
            <b>Q. Preambulatory Matter and Headings. </b>The Preamble to this Agreement shall be deemed to
            form an integral part hereof. Section and subsection headings of this Agreement are inserted for
            convenience only and shall not be deemed to constitute a part hereof nor to affect the meaning
            thereof.
          </p>
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal">
            <b>R. No Drafter. </b>All parties have had the opportunity to have this Agreement reviewed by
            legal counsel of their own choosing. This Agreement shall accordingly be construed mutually and
            reciprocally, and not more favorably with respect to any party on the basis of draftsmanship.
          </p>
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal">
            <b>S. Force Majeure. </b>&quot;Force Majeure&quot; is an external unforeseeable and irresistible
            event arising from no fault or cause by a party, making it absolutely impossible to fulfill an
            obligation. No party shall be responsible for any failure to perform due to reasonably
            unforeseeable circumstances or to causes beyond its respective reasonable control, including but
            not limited to acts of God; war, riot, embargoes, acts of civil or military authority, or
            terrorism; fire, flood, earthquakes, hurricanes, tropical storms or other natural disasters; fiber
            cuts; strikes, or shortages in transportation, facilities, fuel, energy, labor or materials;
            failure of the telecommunications or information services infrastructure; hacking, spam, or any
            failure of a computer, server or software, for such time as a Force Majeure event prevents
            performance.
          </p>
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal">
            <b>T. Nonassignability. </b>The duties and obligations of each party under this Agreement are
            unique and personal; but for the knowledge of each party concerning the other parties and their
            ability and reputation, no such party would enter into this Agreement. Accordingly, the assignment
            of any right, duty, or obligation under this Agreement is prohibited, except on the written
            consent of all parties to this Agreement.
          </p>
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal">
            <b>U. Number and Gender. </b>Where appropriate, the singular number set forth in this Agreement
            shall be interpreted as the plural number, and the gender shall be interpreted as masculine,
            feminine or neuter, as the context dictates.
          </p>
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal">
            <b>V. Currency</b>. The currency used for purposes of this Agreement shall be in United States
            Dollars.
          </p>
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal">
            <b>W. Controlling Law. </b>The parties mutually agree and stipulate that performance and any
            breach of this contract may have effects in a wide range of political and legal jurisdictions
            throughout the world because this Agreement contemplates Internet commerce through the World Wide
            Web, which is limited by no national boundaries; This Agreement anticipates international
            commerce. In order to assure a fixed set of legal principles, the laws of Romania (without respect
            to its choice of governing law provisions) shall govern the meaning and construction of this
            Agreement and all rights conferred by this Agreement in any arbitration or litigation hereunder.
          </p>
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal">
            <b>
              <u>X. Arbitration. </u>
            </b>
            <u>
              Any controversy or claim arising out of or relating to this Agreement, or the breach thereof,
              shall be settled by arbitration administered by the American Arbitration Association in
              accordance with its Commercial Arbitration Rules including the Optional Rules for Emergency
              Measures of Protection, and judgment on the award rendered by the arbitrator(s) may be entered
              in the courts described in Paragraph Y. Should it be impractical or impossible to obtain
              arbitration under the auspices of the American Arbitration Association in the place set forth in
              Paragraph Y., each party shall select one arbitrator, the arbitrators shall one independent
              arbitrator, and arbitration shall proceed under to conduct arbitration in accordance with the
              American Arbitration Associationís rules as set forth herein and the decision of such
              arbitrators shall have the same effect as though rendered by a panel of the American Arbitration
              Association.
            </u>
          </p>
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal">
            <b>Y. Place of Resolution Process. </b>
            In any action brought by either party, the process of mediation, arbitration, and/or litigation
            shall occur exclusively in the country of Romania or such other place as the parties may agree in
            writing. To the extent that Paragraph X. does not bar litigation, the parties each respectively
            submit to the exclusive jurisdiction of the courts sitting in the state of Romania concerning any
            dispute that shall arise under this Agreement and for the purposes described in Paragraph X.
          </p>
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal">
            <b>Z. Signatories Authorized To Bind Parties. </b>Each signatory to this Agreement, in
            consideration of the attention, evaluation, and consideration given to the pending application,
            warrants and swears under the penalties provided in law for false swearing and perjury, that the
            signatory has the power and legal authority to enter into and execute this Agreement on behalf of
            any business entity applicant, that the execution by such signatory has been duly authorized by
            all necessary corporate (or other entity) action, and that this Agreement constitutes a valid,
            binding obligation on the respective parties, without the necessity or condition of any further
            action whatsoever by directors, shareholders, receivers, administrators, owners or other persons
            of any nature whatsoever, to become enforceable in accordance with this Agreement.
          </p>
          <p class="MsoNormal">&nbsp;</p>
          <p class="MsoNormal">
            <b>AA. Execution. </b>The parties agree that this Agreement may be executed digitally online by
            you, now applying to participate in our Affiliate Agreement, and it may be accepted by us, 
            Herodot SRL, by notifying you that your application has been accepted in accordance with the
            provisions of Paragraph A. of this Agreement. It shall be treated in all respects as having been
            executed in the country of Romania.
          </p>
        </div>
      </div>
    );
  }
}
export default Cashplane;
